import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';

import { reducer as hardwareComponentsWidgetReducer } from './slices/HardwareComponentsWidget';
import { reducer as actionWidget } from './slices/actionWidget';
import { reducer as alertsReducer } from './slices/alertManager';
import { reducer as alertPoliciesReducer } from './slices/alertPolicies';
import { reducer as alertsWidgetReducer } from './slices/alertsWidget';
import { reducer as backendReducer } from './slices/backend';
import { reducer as baldurParametersReducer } from './slices/baldur/parameters';
import { reducer as baldurSchedulerReducer } from './slices/baldur/scheduler';
import { reducer as cameraWidgetsReducer } from './slices/cameraWidgets';
import { reducer as cloudLoggingInterfaceReducer } from './slices/cloudLoggingInterface';
import { reducer as dashboardMetricsReducer } from './slices/dashboardMetrics';
import { reducer as eventsReducer } from './slices/event';
import { reducer as fleetControlReducer } from './slices/fleetControl';
import { reducer as groupReducer } from './slices/group';
import { reducer as HardwareAlertsWidgetReducer } from './slices/hardwareAlertsWidget';
import { reducer as layoutsReducer } from './slices/layouts';
import { reducer as linkReducer } from './slices/link';
import { reducer as metricsReducer } from './slices/metrics';
import { reducer as navigationReducer } from './slices/navigation';
import { reducer as pipelineMonitoringReducer } from './slices/pipelineMonitoring';
import { reducer as robotConfigurationReducer } from './slices/robotConfiguration';
import { reducer as robotMonitoringReducer } from './slices/robotMonitoring';
import { reducer as robotServicingReducer } from './slices/robotServicing';
import { reducer as robotStatusReducer } from './slices/robotStatus';
import { reducer as schedulerReducer } from './slices/scheduler';
import { reducer as serviceMetadataReducer } from './slices/serviceMetadata';
import { reducer as serviceMonitoringReducer } from './slices/serviceMonitoring';
import { reducer as servicingHistoryWidgetReducer } from './slices/servicingHistoryWidget';
import { reducer as sessionReducer } from './slices/session';
import { reducer as snackAlertReducer } from './slices/snackAlert';
import { reducer as storeReducer } from './slices/store';
import { reducer as storeManagementReducer } from './slices/storeConfig';
import { reducer as timelineTraceReducer } from './slices/timelineTrace';
import { reducer as mappingJobsReducer } from './slices/mappingJobs';
import { reducer as mapMetadataReducer } from './slices/mapMetadataFile';

export default function _createStore(services) {
  return createStore(
    combineReducers({
      snackAlert: snackAlertReducer,
      session: sessionReducer,
      pipelineMonitoring: pipelineMonitoringReducer,
      serviceMonitoring: serviceMonitoringReducer,
      navigation: navigationReducer,
      metrics: metricsReducer,
      serviceMetadata: serviceMetadataReducer,
      alertPolicies: alertPoliciesReducer,
      backend: backendReducer,
      fleetControl: fleetControlReducer,
      scheduler: schedulerReducer,
      alertsWidget: alertsWidgetReducer,
      hardwareAlertsWidget: HardwareAlertsWidgetReducer,
      hardwareComponentsWidget: hardwareComponentsWidgetReducer,
      robotMonitoring: robotMonitoringReducer,
      servicingHistoryWidget: servicingHistoryWidgetReducer,
      actionWidget: actionWidget,
      robotServicing: robotServicingReducer,
      cameraWidgets: cameraWidgetsReducer,
      group: groupReducer,
      alerts: alertsReducer,
      cli: cloudLoggingInterfaceReducer,
      robotConfiguration: robotConfigurationReducer,
      events: eventsReducer,
      timelineTrace: timelineTraceReducer,
      dashboardMetrics: dashboardMetricsReducer,
      layouts: layoutsReducer,
      baldurScheduler: baldurSchedulerReducer,
      baldurParameters: baldurParametersReducer,
      robotStatus: robotStatusReducer,
      store: storeReducer,
      link: linkReducer,
      storeManagement: storeManagementReducer,
      mappingJobs: mappingJobsReducer,
      mapMetadata: mapMetadataReducer
    }),
    applyMiddleware(thunk.withExtraArgument({ services }))
  );
}
